import {
  Box,
  IconButton,
  Stack,
  styled,
  SvgIcon,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ChampionBadgeInfoDialog from "./ChampionBadgeInfoDialog";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import Image from "next/image";
import QueenLogo from "../../assets/images/queen.png";

const ChampionBadgeContainer = styled(Box)`
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 0.5px solid #626262;
  padding-right: 8px;
  padding-left: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  margin: 3px 0px;
`;

const ChampionBadge = ({
  isChampion = false,
  champion,
  variant,
  fromProfile = false,
}: {
  isChampion: boolean;
  champion: string;
  variant?: string;
  fromProfile?: boolean;
}) => {
  const [isInfoDialogVisible, setIsInfoDialogVisible] =
    useState<boolean>(false);

  if (!isChampion) {
    return null;
  }

  return (
    <>
      <Stack direction={"row"} spacing={0.5} alignItems="center">
        {fromProfile ? (
          <>
            <Image
              src={QueenLogo}
              objectFit="contain"
              alt="queen"
              width={20}
              height={20}
            />
            <Typography
              fontSize={14}
              color="#f42b4d"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsInfoDialogVisible(true);
              }}
            >
              champion - {champion || ""}
            </Typography>
          </>
        ) : (
          <ChampionBadgeContainer
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setIsInfoDialogVisible(true);
            }}
          >
            <Image
              src={QueenLogo}
              objectFit="contain"
              alt="queen"
              width={15}
              height={15}
            />
            <Typography
              fontSize={12}
              color="#f42b4d"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
            >
              champion - {champion || ""}
            </Typography>
          </ChampionBadgeContainer>
        )}
      </Stack>
      <ChampionBadgeInfoDialog
        open={isInfoDialogVisible}
        onClose={() => {
          setIsInfoDialogVisible(false);
        }}
      />
    </>
  );
};

export default ChampionBadge;
